export const SHOW_DEMO_SESSIONS = 'SHOW_DEMO_SESSIONS';

export const showDemoSessions = (isSessionVisible: boolean, storeGuid?: string) => ({
    type: SHOW_DEMO_SESSIONS,
    payload: isSessionVisible,
    storeGuid,
});
